import { v6EmilyShoppingWindowDress } from './../../src/shell/PropertiesDeclarations';
import Character from "@lss/common/src/shell/Character";
import { TimageINT } from '../../src/store/slices/gameObjectSlice';
import { parseRequire } from '../../src/utils/parseImageUrl';

interface EmilyPropertiesINT {
    v6PickedDress?: v6EmilyShoppingWindowDress;
    relation: string,
}

const emilyProperties: EmilyPropertiesINT = {
    relation: "roommate",

};

const emily = new Character<EmilyPropertiesINT>("Emily", emilyProperties, "#FF63C7FF", undefined);

export {
    emily,
};
